export interface ComparisonRowData {
  problem: {
    iconSrc: string;
    iconAlt: string;
    title: string;
    description: string;
  };
  solution: {
    iconSrc: string;
    iconAlt: string;
    title: string;
    description: string;
  };
}

export const comparisonRowsData: ComparisonRowData[] = [
  {
    problem: {
      iconSrc: '/assets/icons/icon_prob_email.webp',
      iconAlt: 'Endless resume emails',
      title: 'Endless resume emails',
      description: 'Hiring managers are buried in unorganized inbox chaos.',
    },
    solution: {
      iconSrc: '/assets/icons/icon_sol_compare.webp',
      iconAlt: 'Side-by-side comparison',
      title: 'Side-by-side comparison',
      description:
        'Compare vetted profiles and resumes — submitted by agencies within your posted fee structure.',
    },
  },
  {
    problem: {
      iconSrc: '/assets/icons/icon_prob_visibility.webp',
      iconAlt: 'No visibility',
      title: 'No visibility',
      description: 'Zero insight into agency performance or candidate sources.',
    },
    solution: {
      iconSrc: '/assets/icons/icon_sol_status.webp',
      iconAlt: 'Real-time status tracking',
      title: 'Real-time status tracking',
      description:
        'Easily track your candidates in the pipeline and provide updates. All in one place — no more update emails and spreadsheets.',
    },
  },
  {
    problem: {
      iconSrc: '/assets/icons/icon_prob_duplicate.webp',
      iconAlt: 'Duplicate submissions',
      title: 'Duplicate submissions',
      description: 'Wasting time filtering the same candidate from multiple agencies.',
    },
    solution: {
      iconSrc: '/assets/icons/icon_sol_limits.webp',
      iconAlt: 'Agencies submit only their best',
      title: 'Clear submission limits',
      description: 'Agencies submit only their best; no flooding allowed.',
    },
  },
  {
    problem: {
      iconSrc: '/assets/icons/icon_prob_timeline.webp',
      iconAlt: 'Unpredictable timelines',
      title: 'Unpredictable timelines',
      description: 'No idea when candidates will arrive or if the role is being worked on.',
    },
    solution: {
      iconSrc: '/assets/icons/icon_sol_performance.webp',
      iconAlt: 'Performance visibility',
      title: 'Performance visibility',
      description: 'Data-driven insights into which agencies deliver.',
    },
  },
  {
    problem: {
      iconSrc: '/assets/icons/icon_prob_cost.webp',
      iconAlt: 'High upfront costs',
      title: 'High upfront costs',
      description: 'Expensive retainers with no guarantee of success.',
    },
    solution: {
      iconSrc: '/assets/icons/icon_sol_success.webp',
      iconAlt: 'Pay only on success',
      title: 'Pay only on success',
      description:
        'Stay within your budget — you choose how much you will pay service fees to recruiters and what guarantee on placement you need.',
    },
  },
];
